import service from '@/utils/server';

const modName='/tms/settlementCostIncomeReport/';
//查询
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};

//导出数据
export const exportData = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'export',
    method: 'post',
    data
  });
};


//汇总
export const summary = data => {
  return service({
    url: modName + 'summary',
    method: 'post',
    data
  });
};



// WEBPACK FOOTER //
// ./src/page/settlementFee/settlementCostIncomeReport/api/index.js